<!-- /src/components/common/BaseInput.vue -->
<template>
  <div class="form__control">
    <label v-if="label">{{ label }}</label>
    <input
      :value="value"
      @input="updateValue"
      v-bind="$attrs"
      v-on="listeners"
    />
  </div>
</template>

<script>
import { formFieldMixin } from '@/mixins/formFieldMixin'
export default {
  mixins: [formFieldMixin],
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
      }
    },
  },
}
</script>

<style scoped>
.header_search__input {
  input[type='text'] {
    background-color: rgba(0, 0, 0, 0.25);
    border: none;
    padding: 0.75rem 0.75rem;
    color: white;
    opacity: 0;
    transition: opacity 0.2s ease;
    will-change: opacity;
    box-shadow: inset 0 0 1rem rgba(0, 0, 0, 0.25);

    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: white;
    }

    &::-moz-placeholder {
      /* Firefox 19+ */
      color: white;
    }

    &:-ms-input-placeholder {
      /* IE 10+ */
      color: white;
    }

    &:-moz-placeholder {
      /* Firefox 18- */
      color: white;
    }
  }
}
</style>
